import React from "react";
import FactCarousel from "../component/youtube/FactCarousel";
import WhyItMatters from "../component/youtube/WhyItMatters";
import CTASection from "../component/youtube/CTASection";
import Hero from "../sections/SocialHero";
import FactCard from "../component/youtube/FactCard";
import { LanguageCode, pickLang } from "../utils/translations";

interface YouTubeInsightsProps {
  lang: LanguageCode;
}

const YouTubeInsights: React.FC<YouTubeInsightsProps> = ({ lang }) => {
  const heroContent = {
    en: {
      titleMain: "YouTube Insights",
      titleHighlight: "That Actually Matter",
      subtitle: "Facts from the most popular YouTube videos of all time.",
      ctaText: "Explore Trends",
    },
    hi: {
      titleMain: "यूट्यूब इनसाइट्स",
      titleHighlight: "जो वास्तव में मायने रखते हैं",
      subtitle: "अब तक के सबसे लोकप्रिय YouTube वीडियो के तथ्य।",
      ctaText: "ट्रेंड्स देखें",
    },
    fr: {
      titleMain: "Aperçus YouTube",
      titleHighlight: "qui comptent vraiment",
      subtitle: "Des faits tirés des vidéos YouTube les plus populaires de tous les temps.",
      ctaText: "Explorer les tendances",
    },
  };

  const { titleMain, titleHighlight, subtitle, ctaText } = pickLang(
    heroContent,
    lang
  );

  const factCardContent = {
    en: {
      title: "The MrBeast Effect",
      description:
        "High-retention editing and extreme thumbnails are the current gold standard for viral growth.",
      topVideos: "Top videos",
    },
    hi: {
      title: "MrBeast इफ़ेक्ट",
      description:
        "हाई-रिटेंशन एडिटिंग और चरम थंबनेल वायरल ग्रोथ के लिए मौजूदा स्वर्ण मानक हैं।",
      topVideos: "टॉप वीडियो",
    },
    fr: {
      title: "L'effet MrBeast",
      description:
        "Un montage à forte rétention et des miniatures extrêmes sont la référence actuelle pour une croissance virale.",
      topVideos: "Meilleures vidéos",
    },
  };

  const {
    title: factTitle,
    description: factDescription,
    topVideos,
  } = pickLang(factCardContent, lang);

  return (
    // FIXED: Removed the top padding (changed from 60px to 0) to eliminate the gap after Navbar
    // Reduced bottom padding to tighten space between components
    <div style={{ padding: "0 8% 40px" }}>
      <div style={{ marginTop: "-10px" }}>
        {" "}
        {/* Pulls Hero up slightly if Hero has internal padding */}
        <Hero
          lang={lang}
          title={{
            main: titleMain,
            highlight: titleHighlight,
          }}
          subtitle={subtitle}
          ctaText={ctaText}
        />
      </div>

      {/* Added a small negative margin to bridge the gap between Hero and FactCard */}
      <div style={{ marginTop: "-30px" }}>
        <FactCard
          lang={lang}
          labels={{
            topVideos,
          }}
          title={factTitle}
          description={factDescription}
          videos={[
            { title: "$1 vs $500,000 Plane Ticket", year: 2023 },
            { title: "I Built Willy Wonka's Chocolate Factory", year: 2022 },
          ]}
        />
      </div>

      <FactCarousel lang={lang} />
      <WhyItMatters lang={lang} />
      <CTASection lang={lang} />
    </div>
  );
};

export default YouTubeInsights;
